import { render } from "./AboutView.vue?vue&type=template&id=6e7255ab"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"

import "./AboutView.vue?vue&type=style&index=0&id=6e7255ab&lang=css"

import exportComponent from "/tmp/build_37390889/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__